import Vue from "vue";
import TeamFilter from "@/services/axios/modules/teamFilter";
import ManagerFilter from "@/services/axios/modules/managerFilter";
import BrokerFilter from "@/services/axios/modules/brokerFilter";
const moment = require('moment')
require('moment/locale/pt-br')

const getDefaultState = () => {
  let savedState = localStorage.getItem('dashboard_state');
  if (savedState){
    return { ...JSON.parse(savedState), loading: false };
  }
  return {
    loading: false,
    // Filtros pendentes que o usuário está editando
    dynamicFilters: {
      // filtro de data de periodo: dia, mês, ano
      timePeriod:"",
      // filtro de data de range
      dateRange: {
        initialDate: "",
        finalDate: ""
      },
      // filtro do comparativo data
      comparativeDate: {
        initialDate: "",
        finalDate: ""
      },
      // filtro de equipe, gerente, corretor
      teamFilter: {
          team: [],
          manager: [],
          broker: []
      }
    },
    // Filtros aplicados que serão usados para carregar os dados
    appliedFilters: {
      // Inicialmente, pode ser uma cópia dos filtros iniciais
      timePeriod: "",
      dateRange: {
        initialDate: "",
        finalDate: ""
      },
      comparativeDate: {
        initialDate: "",
        finalDate: ""
      },
      teamFilter: {
        team: [],
        manager: [],
        broker: []
      }
    },
    // Pega os valores das equipes, gerentes e corretores
    dynamicTeam: {
        team: [],
        manager: [],
        broker: []
    },
  }
}

export const dashboardFilter = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
      async fetchTeams({ commit, state }, payload) {
        try {
          const teamFilterService = new TeamFilter()
          const response = await teamFilterService.getTeams(
            { 
              page: payload?.page, 
              per_page: payload?.perPage || 7, 
              search: payload?.search 
            })
          const teamsResponse = response.data.data; 

          const teams = {
            currentPage: teamsResponse?.current_page,
            lastPage: teamsResponse?.last_page,
            data: payload?.nextPage ? [...state.dynamicTeam.team.data, ...teamsResponse.data] : teamsResponse?.data
          } 

          commit('SET_TEAMS', teams);  
          commit('SET_MANAGERS', []);  
        } catch (error) {
          if (error.response?.data?.msg) {
              Vue.prototype.$toastr.e(error.response.data.msg)
          }
          Vue.prototype.$toastr.e("Erro ao buscar Equipes")
        }
      } ,
      async fetchManagers({ commit, state }, payload) {
        try {
          const managerFilterService = new ManagerFilter();
          const selectedTeams = state.dynamicFilters.teamFilter.team;
          const params = { 
            page: payload?.page, 
            per_page: payload?.perPage || 7, 
            search: payload?.search 
          };
      
          if (selectedTeams.length > 0) {
            params.teams = selectedTeams.map(selected => selected.id).join(',');
          }

          const response = await managerFilterService.getManagers(params);

          const transformData = (managersData) => {
            const managers = [...managersData]
            return managers.map(manager => ({ 
                id: manager?.manager_id || manager.id, 
                name: manager?.first_name || manager.name, 
                team: manager?.team,
              }))
          } 

          const managers = {
            currentPage: response?.data?.data?.current_page,
            lastPage: response?.data?.data?.last_page,
            data: payload?.nextPage ? [ ...transformData(state.dynamicTeam.manager.data), ...transformData(response.data?.data?.data)] : transformData(response?.data?.data?.data)
          }

          commit('SET_MANAGERS', managers);
          commit('SET_BROKERS', []);
        } catch (error) {
          if (error.response?.data?.msg) {
            Vue.prototype.$toastr.e(error.response.data.msg)
          }
          Vue.prototype.$toastr.e("Erro ao buscar gerentes")
        }
      },
      async fetchBrokers({ commit, state }, payload) {
        try {
          const brokerFilterService = new BrokerFilter();
          const selectedManagers = state.dynamicFilters.teamFilter.manager;
          const params = { 
            page: payload?.page, 
            per_page: payload?.perPage || 7, 
            search: payload?.search 
          }
          if (selectedManagers.length > 0) {
            params.managers = selectedManagers.map(selected => selected.id).join(',');
          }
          const response = await brokerFilterService.getBrokers(params);

          const transformData = (brokersData) => {
            const brokers = [...brokersData]
            return brokers.map(broker => ({ 
                id: broker?.broker_id || broker.id, 
                name: broker?.broker_name || broker.name, 
                manager: broker?.manager_name || broker.manager,
              }))
          } 

          const brokers = {
            currentPage: response?.data?.data?.current_page,
            lastPage: response?.data?.data?.last_page,
            data: payload?.nextPage ? [ ...transformData(state.dynamicTeam.broker.data), ...transformData(response.data?.data?.data)] : transformData(response?.data?.data?.data)
          }
          commit('SET_BROKERS', brokers);
        } catch (error) {
          if (error.response?.data?.msg) {
            Vue.prototype.$toastr.e(error.response.data.msg)
          }
            Vue.prototype.$toastr.e("Erro ao buscar corretores")
          }
      },
      async updateTeamFilter({ commit }, payload) {
        commit('UPDATE_TEAM_FILTER', payload);
      },
      applyFilters({ commit }) {
        commit('APPLY_FILTERS');
      },    
      resetFilters({ commit }) {
        commit('RESET_FILTERS');
      },

    },
    getters: {
    },
    mutations: {
        SET_TEAMS(state, teams) {
          Vue.set(state.dynamicTeam, 'team', teams)
        },
        SET_MANAGERS(state, managers) {
          Vue.set(state.dynamicTeam, 'manager', managers)
        },
        SET_BROKERS(state, brokers) {
          Vue.set(state.dynamicTeam, 'broker', brokers)
        },
        UPDATE_TEAM_FILTER(state, { filterType, selectedValues }) {
          // Verifica se os valores selecionados são iguais aos valores já existentes
          const currentValues = state.dynamicFilters.teamFilter[filterType] || [];
          const areValuesEqual = JSON.stringify(currentValues) === JSON.stringify(selectedValues);

          // Se os valores são iguais, não faz nada e retorna
          if (areValuesEqual) {
            return;
          }
      
          // Atualiza a propriedade correta no teamFilter com base no filterType
          Vue.set(state.dynamicFilters.teamFilter, filterType, [...selectedValues]);
      
            if (filterType === "team") {
              Vue.set(state.dynamicFilters.teamFilter, 'manager', []);
              Vue.set(state.dynamicTeam, 'manager', []);
              Vue.set(state.dynamicFilters.teamFilter, 'broker', []);
              Vue.set(state.dynamicTeam, 'broker', []);
            } 
            if (filterType === "manager") {
              Vue.set(state.dynamicFilters.teamFilter, 'broker', []);
              Vue.set(state.dynamicTeam, 'broker', []);          
            }
        },
        // Atualiza o periodo
        UPDATE_PERIOD_TYPE(state, period) {
          Vue.set(state.dynamicFilters, 'timePeriod', period);
          if(period === 'day'){
            Vue.set(state.dynamicFilters, 'dateRange', {initialDate: moment(new Date()).format('YYYY-MM-DD'), finalDate: moment(new Date()).format('YYYY-MM-DD')})
          }
          if(period === 'week'){
            Vue.set(state.dynamicFilters, 'dateRange', {initialDate: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'), finalDate: moment(new Date()).format('YYYY-MM-DD')})
          }
          if(period === 'month'){
            Vue.set(state.dynamicFilters, 'dateRange', {initialDate: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'), finalDate: moment(new Date()).format('YYYY-MM-DD')})
          }
        },
        // Atualiza o range de data
        UPDATE_DATE_RANGE(state, { initialDate, finalDate }) {
          Vue.set(state.dynamicFilters, 'dateRange', { initialDate, finalDate})
          Vue.set(state.dynamicFilters, 'timePeriod', "")
        },
        // Atualiza os dados comparativos
        UPDATE_COMPARATIVE_DATA(state, { initialDate, finalDate }) {
          Vue.set(state.dynamicFilters, 'comparativeDate', { initialDate, finalDate})
        },

        APPLY_FILTERS(state) {
          // Faz uma cópia profunda de dynamicFilters para evitar problemas de reatividade
          state.appliedFilters = JSON.parse(JSON.stringify(state.dynamicFilters));

          const stateToSave = {
            dynamicFilters: state.dynamicFilters,
            appliedFilters: state.appliedFilters,
            dynamicTeam: state.dynamicTeam
          };
      
          // Salva o estado no localStorage
          localStorage.setItem('dashboard_state', JSON.stringify(stateToSave));
        },      

        RESET_FILTERS(state) {
          localStorage.removeItem('dashboard_state');
          Object.assign(state, getDefaultState());
        },

        SET_LOADING(state, loading) {
          state.loading = loading;
        },
      
      }
}